import React, { useEffect, useMemo, useState } from "react";
import vDesktop from "../../assets/hero/desktopv.mp4";
import vMobile from "../../assets/hero/mobilev.mp4";
import heroPoster from "../../assets/hero/image.png"; // 👈 lightweight JPG preview

// Hook: true on ≥768px
const useIsDesktop = () => {
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia("(min-width:768px)").matches
      : true
  );
  useEffect(() => {
    const mq = window.matchMedia("(min-width:768px)");
    const handler = e => setIsDesktop(e.matches);
    mq.addEventListener
      ? mq.addEventListener("change", handler)
      : mq.addListener(handler);
    return () =>
      mq.removeEventListener
        ? mq.removeEventListener("change", handler)
        : mq.removeListener(handler);
  }, []);
  return isDesktop;
};

const Hero = () => {
  const isDesktop = useIsDesktop();
  const src = useMemo(() => (isDesktop ? vDesktop : vMobile), [isDesktop]);

  return (
    <section className="relative h-screen w-full overflow-hidden">
      <video
        key={src}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        poster={heroPoster}   // 👈 instant first paint
        className="absolute inset-0 w-full h-full object-cover brightness-50"
      >
        {/* 👇 let browser choose automatically if you prefer */}
        <source src={vMobile} type="video/mp4" media="(max-width: 767px)" />
        <source src={vDesktop} type="video/mp4" media="(min-width: 768px)" />
        {/* fallback */}
        <source src={src} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </section>
  );
};

export default Hero;
